import { ElementType } from 'react'
import { FormItem } from './Component'

export interface BasicFormItemProps {
  component: ElementType
  ignoreErrorKeys?: string[]
  label?: string
  initialValue?: string | number
  info?: string
  helperText?: string
  layout?: 'horizontal' | 'vertical'
  noMargin?: boolean
  name: string
  unit?: string
  placeholder?: string
  showErrorHelperText?: boolean
  disabled?: boolean
  country?: string
}

export const BasicFormItem = ({
  ignoreErrorKeys,
  label,
  component: Component,
  initialValue,
  info,
  helperText,
  layout,
  noMargin,
  ...props
}: BasicFormItemProps) => (
  <FormItem
    helperText={helperText}
    ignoreErrorKeys={ignoreErrorKeys}
    info={info}
    initialValue={initialValue}
    label={label}
    layout={layout}
    noMargin={noMargin}
    {...props}
  >
    <Component {...props} />
  </FormItem>
)
